import React from "react";

export class GameErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Game crashed:", error, info);
  }

  reset = () => this.setState({ hasError: false });

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="game-error-fallback" className="rounded-lg border-2 border-dashed border-kirana-brown bg-kirana-cream/60 p-6 text-center">
          <p className="font-signboard text-lg font-bold text-kirana-brown">Arre! Ye khel thoda atak gaya 😅</p>
          <p className="mt-1 text-sm text-kirana-brown/70">Something went wrong in this game. Try again.</p>
          <button
            data-testid="game-error-retry"
            onClick={this.reset}
            className="mt-4 inline-flex items-center gap-2 rounded-md border-[3px] border-kirana-brown bg-kirana-gold px-5 py-2 font-bold text-kirana-brown transition-transform hover:scale-105 hard-shadow-sm"
          >
            Try Again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
